import pluralize from "pluralize";

import { IgAlert } from "@intelligems/ig-theme/IgAlert";
import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useProductPickerContext } from "@src/components/MainApp/SharedProductPicker/ProductPickerContext";
import { useDispatch, useSelector } from "@src/store";
import {
  getProductPickerFilters,
  getProductPickerProductCount,
  getProductPickerSelectedCount,
} from "@src/store/slices/productPicker";
import { shouldProductPickerShowSelectAll } from "@src/store/slices/productPicker/selectors/shouldProductPickerShowSelectAll";
import { loadAndSelectAll } from "@src/store/slices/productPicker/thunks/loadAndSelectAll";

export const SelectAllMessage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { dataSource } = useProductPickerContext();
  const selectedCount = useSelector(getProductPickerSelectedCount);
  const totalCount = useSelector(getProductPickerProductCount);
  const filters = useSelector(getProductPickerFilters);
  const selectedMessage = `Only ${selectedCount} ${pluralize("product", selectedCount)} ${pluralize("is", selectedCount)} selected`;
  const shouldShow = useSelector(shouldProductPickerShowSelectAll);
  if (!shouldShow) {
    return null;
  }

  const onSelectAll = () => {
    void dispatch(loadAndSelectAll(dataSource));
  };

  return (
    <Grid sx={{ paddingX: 4, paddingTop: 2 }}>
      <IgAlert
        severity={"info"}
        message={
          <IgTypography>
            {selectedMessage}.{" "}
            <IgLink onClick={onSelectAll}>
              {!filters.collection_id
                ? `Select all ${totalCount} products.`
                : "Select all products"}
            </IgLink>{" "}
          </IgTypography>
        }
        alertKey={"select-all-message"}
      />
    </Grid>
  );
};
